import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import authSlice from "../screens/auth/authSlice";
import appLayoutSlice from "../components/layout/appLayoutSlice";
import otpSlice from "../screens/auth/otpSlice";
import merchantForm from "../slice/merchantSlice";
import hostForm from "../slice/hostSlice";
import tripSlice from "../slice/tripSlice";
import shortSlice from "../slice/shortSlice";
import reviewSlice from "../slice/reviewSlice";

const appReducer = combineReducers({
  auth: authSlice.reducer,
  appLayout: appLayoutSlice.reducer,
  otp: otpSlice.reducer,
  merchantForm: merchantForm,
  hostForm: hostForm,
  trips: tripSlice,
  shorts: shortSlice,
  reviews: reviewSlice,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/logout") {
    state = undefined;
    console.log("Clearing state on logout");
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
